import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "gallery-modal-wrapper"
}
const _hoisted_2 = { class: "gallery-modal" }
const _hoisted_3 = { class: "gallery-modal__header" }
const _hoisted_4 = { class: "gallery-modal__count" }
const _hoisted_5 = { class: "gallery-modal__nav-buttons" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 0,
  class: "gallery-modal__title"
}
const _hoisted_9 = { class: "gallery-modal__buttons" }
const _hoisted_10 = ["href"]
const _hoisted_11 = ["src"]
const _hoisted_12 = ["src", "alt"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($setup.gallery_options && $setup.gallery_options.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, _toDisplayString($setup.getCount()), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                class: _normalizeClass(["gallery-modal__nav-prev", { 'gallery-modal__nav-prev--disabled': $setup.first_selected }]),
                disabled: $setup.first_selected,
                onClick: $setup.viewPrev
              }, null, 10 /* CLASS, PROPS */, _hoisted_6),
              _createElementVNode("button", {
                class: _normalizeClass(["gallery-modal__nav-next", { 'gallery-modal__nav-next--disabled': $setup.last_selected }]),
                disabled: $setup.last_selected,
                onClick: $setup.viewNext
              }, null, 10 /* CLASS, PROPS */, _hoisted_7)
            ]),
            ($setup.selected_option.title)
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString($setup.selected_option.title), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_9, [
              ($props.config.downloadable && $setup.selected_option.image_url)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "gallery-modal__button",
                    href: $setup.selected_option_image_download_url
                  }, " Download ", 8 /* PROPS */, _hoisted_10))
                : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("button", {
              class: "gallery-modal__close-modal",
              onClick: _cache[0] || (_cache[0] = $event => ($setup.emit( 'close-modal' )))
            })
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["gallery-modal__content", { 'gallery-modal__content--show-sidebar': _ctx.show_comments }])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["gallery-modal__content-wrapper", { 'gallery-modal__content-wrapper--full-resolution': $setup.show_full_resolution }])
            }, [
              ($setup.loading)
                ? (_openBlock(), _createBlock($setup["PageLoaderComponent"], { key: 0 }))
                : _createCommentVNode("v-if", true),
              ($setup.selected_option.image_url)
                ? _withDirectives((_openBlock(), _createElementBlock("img", {
                    key: 1,
                    class: _normalizeClass(["gallery-modal__image", { 'gallery-modal__image--full-resolution': $setup.show_full_resolution }]),
                    style: _normalizeStyle($setup.full_resolution_styles),
                    src: $setup.selected_option.image_url,
                    onLoad: _cache[1] || (_cache[1] = $event => ($setup.loading = false)),
                    onClick: $setup.toggleFullResolution
                  }, null, 46 /* CLASS, STYLE, PROPS, HYDRATE_EVENTS */, _hoisted_11)), [
                    [_vShow, !$setup.loading]
                  ])
                : ($setup.selected_option.video_url)
                  ? _withDirectives((_openBlock(), _createElementBlock("video", {
                      key: 2,
                      class: "gallery-modal__video",
                      src: $setup.selected_option.video_url,
                      alt: $setup.selected_option.title,
                      autoplay: "",
                      controls: "",
                      onLoadeddata: _cache[2] || (_cache[2] = $event => ($setup.loading = false))
                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_12)), [
                      [_vShow, !$setup.loading]
                    ])
                  : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */)
          ], 2 /* CLASS */)
        ])
      ]))
    : _createCommentVNode("v-if", true)
}